import { useState } from 'react';
import { apiDriverApp } from '../../../../../../libs/apiDriverApp';
import moment from 'moment';
import { transformDriversResponse, transformScheduleResponse } from '../utils/manageData';

export const useScheduleManagementApi = () => {
   const [fetchingData, setFetchingData] = useState(false);
   const [error, setError] = useState(null);

   const getAllDriverSchedules = async (startDate = new Date()) => {
      setFetchingData(true);
      setError(null);

      const formattedDate = moment(startDate).format('YYYY-MM-DD');

      try {
         const { data } = await apiDriverApp.get(
            `api/hr/schedule/get_all_driver_schedules/?start_date=${formattedDate}`
         );

         const sortedData = data.sort((a, b) => {
            if (a.drivers.length === 0 && b.drivers.length > 0) return 1;
            if (b.drivers.length === 0 && a.drivers.length > 0) return -1;

            return a.name.trim().localeCompare(b.name.trim());
         });

         const transformedData = transformScheduleResponse(sortedData);
         return transformedData;
      } catch (err) {
         setError(err);
         throw err;
      } finally {
         setFetchingData(false);
      }
   };

   const getUnassignedDrivers = async () => {
      setFetchingData(true);
      setError(null);

      try {
         const { data } = await apiDriverApp.get(`api/hr/schedule/available_employees/`);

         const transformedData = transformDriversResponse(data);
         return transformedData;
      } catch (err) {
         setError(err);
         throw err;
      } finally {
         setFetchingData(false);
      }
   };

   const getAllCustomDriverShifts = async (showLoading = true) => {
      if (showLoading) setFetchingData(true);
      setError(null);

      try {
         const { data } = await apiDriverApp.get(`api/hr/custom-driver-shifts/get_all_driver_custom_shifts/`);

         return data;
      } catch (err) {
         setError(err);
         throw err;
      } finally {
         setFetchingData(false);
      }
   };

   return {
      fetchingData,
      error,
      getAllDriverSchedules,
      getUnassignedDrivers,
      getAllCustomDriverShifts,
   };
};
